export const operationsForSelectable = [
  'CONSTITUTION',
  'CAPITAL_INCREASE',
  'CAPITAL_DECREASE',
  'SELL_PARTICIPATION',
  'HERITAGE',
  'DONATION',
  'ENDORSEMENT',
  'TRANSMISSION',
  'SPLIT',
  'RENUMERATION',
  'RECLASSIFICATION',
  'DIVIDENDS_DISTRIBUTION',
  'CONTRIBUTION',
  'ENDORSEMENT',
];
